import { IAdobeTargetActivity, IAdobeTargetActivityResponse, isIAdobeTargetActivityError } from '@belong/adobe-target';

export const getABTestAnalyticsData = (
  activities?: Record<string, IAdobeTargetActivityResponse>
): { [key: string]: any } | undefined => {
  if (!activities) {
    return {};
  }

  const activityResponses = Object.values(activities);
  const successfulActivities = activityResponses.filter(
    (item): item is IAdobeTargetActivity => !isIAdobeTargetActivityError(item) && Boolean(item.status)
  );

  if (!successfulActivities.length) {
    const errorActivity = activityResponses.find(item => isIAdobeTargetActivityError(item));
    return errorActivity ? { ...errorActivity } : {};
  }

  const selectedActivity = successfulActivities[0];
  const mboxes = successfulActivities.flatMap(item => item.execute?.mboxes ?? []);
  return {
    ...selectedActivity,
    execute: {
      ...selectedActivity.execute,
      mboxes
    }
  };
};
